import regularAppService from "./regularAppService";

export const getProducts = async () => {
  const page = await regularAppService.getPaginated({ collection: "products" });
  return Array.isArray(page.items) ? page.items : [];
};

export const getProductsPage = async ({
  page,
  limit,
  search,
  selectedTags,
  inventoryFilter,
  sortBy = "updatedAt",
  sortOrder = "desc",
  exact,
} = {}) => {
  const isValidSearch = typeof search === "string" && search.trim().length > 0;
  const hasTags = Array.isArray(selectedTags) && selectedTags.length > 0;

  const filterParts = [];
  if (hasTags) {
    filterParts.push({ tags: { $all: selectedTags } });
  }
  if (inventoryFilter === "with_stock") {
    filterParts.push({ stock: { $gt: 0 } });
  } else if (inventoryFilter === "no_stock") {
    filterParts.push({ stock: { $lte: 0 } });
  }
  const filter = filterParts.length > 0 ? { $and: filterParts } : undefined;

  const result = await regularAppService.getPaginated({
    collection: "products",
    ...(Number.isFinite(Number(page)) ? { page: Number(page) } : {}),
    ...(Number.isFinite(Number(limit)) ? { limit: Number(limit) } : {}),
    ...(isValidSearch ? { search } : {}),
    ...(typeof exact === "boolean" ? { exact } : {}),
    sortBy,
    sortOrder,
    ...(filter ? { filter } : {}),
  });
  return result;
};

export const createProduct = async (productData) => {
  
  const newProduct = {
    ...productData,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  const result = await regularAppService.upsert({ collection: "products", data: newProduct });
  return result;
};

export const updateProduct = async (productData) => {
  const updatedProduct = {
    ...productData,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "products", data: updatedProduct });
  return result;
};

export const deleteProduct = async (productId) => {
  const deletedProduct = {
    _id: productId,
    deleted: true,
    updatedAt: new Date().toISOString(),
  };

  const result = await regularAppService.upsert({ collection: "products", data: deletedProduct });
  return result;
};

export const searchProducts = async ({ search = "" }) => {
  const isValid = typeof search === "string" && search.trim().length > 0;
  const pageResult = await regularAppService.getPaginated({
    collection: "products",
    ...(isValid ? { search } : {}),
  });
  return pageResult.items || [];
};

// Method to force a sync with the server
export const syncProducts = async () => {
  return await getProducts();
};

// Debugging function to reset and check product data
export const debugProducts = async () => {
  return [];
};
